<template>
    <b-modal 
        hide-header 
        hide-footer 
        centered 
        body-class="modal-body" 
        id="onboarding-modal" 
        no-close-on-backdrop 
        no-close-on-esc>
        <b-carousel indicators img-width="700" img-height="400" :interval="0" ref="carousel" v-model="step">
            <b-carousel-slide v-for="img in headerImg" :img-src="img" :key="img">
            </b-carousel-slide>
        </b-carousel>
        <div class="onboarding-modal-text-container">
            <div class="text-center mb-0">
                <h4 class="header-text mx-auto">{{ headerSlide }}</h4>
                <p class="font-size-4 body-text mb-0">
                    {{ bodySlide }}
                </p>
            </div>
            <div class="OM-button-cont">
                <b-button v-if="!isLastStep" class="gold-button" @click="handleClick">
                    Next
                </b-button>
            </div>
            <div class="last-slide-button-container" v-if="isLastStep">
                <b-button pill @click="handleLeftButtonClick">{{ lastSlideButtonText[0] }}</b-button>
                <b-button pill class="route-button" @click="handleRightButtonClick">{{ lastSlideButtonText[1] }}</b-button>
            </div>
        </div>
    </b-modal>
</template>



<script>
import './OnboardingModal.scss';


export default {
    name: 'OnboardingModal',
    emits:['leftButton','rightButton'],
    data: () => ({
        step: 0,
    }),
    props: {
        headerText: {
            type: Array,
            required: true,
        },
        bodyText: {
            type: Array,
            required: true,
        },
        headerImg: {
            type: Array,
            required: true,
        },
        lastSlideButtonText:{
            type: Array,
            required: true
        }
    },
    computed: {
        isLastStep() {
            return this.step === this.headerText.length - 1;
        },
        headerSlide(){
            return this.headerText[this.step]
        },
        bodySlide(){
            return this.bodyText[this.step]
        }
    },
    methods: {
        handleClick() {
            if (!this.isLastStep) {
                this.step += 1
                this.$refs.carousel.next();
            }
        },
        handleLeftButtonClick(){
            this.$emit('leftButton');
        },
        handleRightButtonClick(){
            this.$emit('rightButton');
        },
    },
    created(){

    }
}
</script>
